import { ItemType } from "../../types/Item.ts";

export const EMPTY_ITEM: ItemType = {
  _id: "",
  ownerId: "",
  title: "",
  description: "",
  price: undefined!,
  category: "",
  categoryData: [],
  imageUrls: [],
  text: "",
  status: "active",
  updatedAt: "",
  createdAt: "",
};
